export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/assign_and_review_thumbnail-a92fc66ce600c0c019ee29d011caa09e.png";